export interface Institution {
  id: string;
  name: string;
  type: 'BANCO' | 'FINANCIERA' | 'COOPERATIVA' | 'BILLETERA' | 'GENERAL';
}

export const INSTITUTIONS: Institution[] = [
  // Generales
  { id: 'efectivo', name: 'Efectivo', type: 'GENERAL' },
  { id: 'otros', name: 'Otros', type: 'GENERAL' },

  // Bancos
  { id: 'itau', name: 'Banco Itaú', type: 'BANCO' },
  { id: 'ueno', name: 'ueno bank', type: 'BANCO' },
  { id: 'familiar', name: 'Banco Familiar', type: 'BANCO' },
  { id: 'atlas', name: 'Banco Atlas', type: 'BANCO' },
  { id: 'gnb', name: 'Banco GNB', type: 'BANCO' },
  { id: 'basa', name: 'Banco Basa', type: 'BANCO' },
  { id: 'sudameris', name: 'Sudameris Bank', type: 'BANCO' },
  { id: 'continental', name: 'Banco Continental', type: 'BANCO' },
  { id: 'bnf', name: 'Banco Nacional de Fomento (BNF)', type: 'BANCO' },
  { id: 'rio', name: 'Banco Río', type: 'BANCO' },
  { id: 'bancop', name: 'Bancop', type: 'BANCO' },
  { id: 'interfisa', name: 'Interfisa Banco', type: 'BANCO' },
  { id: 'zeta', name: 'Zeta Banco', type: 'BANCO' },
  { id: 'solar', name: 'Solar Banco', type: 'BANCO' },
  { id: 'do_brasil', name: 'Banco do Brasil', type: 'BANCO' },
  { id: 'citibank', name: 'Citibank', type: 'BANCO' },

  // Financieras
  { id: 'paraguayo_japonesa', name: 'Financiera Paraguayo Japonesa', type: 'FINANCIERA' },
  { id: 'tu_financiera', name: 'Tu Financiera', type: 'FINANCIERA' },
  { id: 'fic', name: 'FIC de Finanzas', type: 'FINANCIERA' },

  // Cooperativas
  { id: 'universitaria', name: 'Cooperativa Universitaria', type: 'COOPERATIVA' },
  { id: 'medalla', name: 'Cooperativa Medalla Milagrosa', type: 'COOPERATIVA' },
  { id: 'san_cristobal', name: 'Cooperativa San Cristóbal', type: 'COOPERATIVA' },
  { id: 'coomecipar', name: 'Coomecipar', type: 'COOPERATIVA' },
  { id: 'chortitzer', name: 'Cooperativa Chortitzer', type: 'COOPERATIVA' },
  { id: 'fernheim', name: 'Cooperativa Fernheim', type: 'COOPERATIVA' },
  { id: 'neuland', name: 'Cooperativa Neuland', type: 'COOPERATIVA' },

  // Billeteras / Fintech
  { id: 'tigo_money', name: 'Tigo Money', type: 'BILLETERA' },
  { id: 'personal_pay', name: 'Personal Pay', type: 'BILLETERA' },
  { id: 'claro_pay', name: 'Claro Pay', type: 'BILLETERA' },
  { id: 'mango', name: 'Mango', type: 'BILLETERA' },
  { id: 'vaquita', name: 'Vaquita', type: 'BILLETERA' },
  { id: 'eko', name: 'Eko', type: 'BILLETERA' },
  { id: 'wally', name: 'Wally', type: 'BILLETERA' },
];

export const getInstitutionById = (id: string): Institution | undefined => {
  return INSTITUTIONS.find(inst => inst.id === id);
};
